import script from "./EditShopHoursDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditShopHoursDialog.vue?vue&type=script&setup=true&lang=js"

import "./EditShopHoursDialog.vue?vue&type=style&index=0&id=461835be&lang=css"

const __exports__ = script;

export default __exports__